module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-file"
  }, [(_vm.label) ? _c('label', {
    staticClass: "form-file__label",
    class: {
      'form-file__label_filename': !!_vm.fileName, 'form-file__label_warnings': !!_vm.warnings, 'form-file__label_error': _vm.vError
    },
    attrs: {
      "for": "file-input",
      "data-text": _vm.attrText
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.required) ? _c('sup', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('input', {
    staticClass: "form-file__input",
    attrs: {
      "type": "file",
      "id": "file-input"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('changeInput', $event)
      }
    }
  }), (_vm.vError) ? _c('div', {
    staticClass: "form-file__text"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e1ed90","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/form/components/file/File.vue
// module id = 92938cdaafcf249dbb8e
// module chunks = 89